import React from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { useStores } from "../../../contexts/StoreContext";
import Icon from "../../Icon/Icon";

const StyledInputWrapper = styled.div`
  border: 1px solid #ccc;
  border-radius: 0;
  outline: none;

  &:focus-within {
    border: ${({ theme }) => `${theme.primaryColor} 1px solid`};
  }
`;
const StyledInput = styled.input`
  height: 3rem;
  border: none;
  outline: none;

  padding-left: 8px;
`;

const StyledClearButton = styled(Icon)`
  color: #ccc;

  &:hover {
    color: #999;
  }
`;

function KeywordFilter(props) {
  const { placeholder, onChange } = props;

  const { filtersStore } = useStores();
  const { setFilter } = filtersStore;

  const handleKeyword = (e) => {
    setFilter("keywords", e.target.value);

    if (onChange) {
      onChange(e.target.value);
    }
  };

  const handleInputClear = () => {
    setFilter("keywords", "");

    if (onChange) {
      onChange();
    }
  };

  return (
    <StyledInputWrapper className="bg-white d-flex flex-grow-1 align-items-center keyword-filter">
      <StyledInput
        aria-label="Keyword search"
        className="w-100"
        onChange={handleKeyword}
        placeholder={placeholder}
        type="text"
        value={filtersStore.filters?.keywords}
      />
      {filtersStore.filters?.keywords && (
        <span onClick={handleInputClear}>
          <StyledClearButton className="me-2" icon="clearInput" size={20} />
        </span>
      )}
    </StyledInputWrapper>
  );
}

export default observer(KeywordFilter);

KeywordFilter.propTypes = {
  onChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
};

KeywordFilter.defaultProps = {
  onChange: null,
};
